/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import React from "react";
import {injectIntl} from "react-intl";
import TreeSelector from "../../common/TreeSelector";


class FleetsHierarchy extends React.Component {

    constructor(props) {
        super(props)

        this.getHierarchyItem = this.getHierarchyItem.bind(this)
    }

    getAssetHierarchyOptions() {
        const {fleetsHierarchy, rootSelectable} = this.props

        return fleetsHierarchy.map(f => {
            return this.getHierarchyItem(f, rootSelectable, 'fleet');
        })
    }

    getHierarchyItem(item, selectable, type) {
        const {showAssets, intl} = this.props;

        let subItems = []
        let hasAssets = false;
        let hasSubFleets = false;

        if (item.subFleets && item.subFleets.length > 0) {
            subItems = subItems.concat(item.subFleets.map(f => {
                return this.getHierarchyItem(f, true, 'fleet')
            }))
            hasSubFleets = true;
        }
        if (item.assets && item.assets.length > 0) {
            if(showAssets) {
                subItems = subItems.concat(item.assets.map(a => {
                    return this.getHierarchyItem(a, true, 'asset')
                }));
            }
            hasAssets = true;
        }
        return {
            id: type + '_' + item.id,
            name: item.name + ((item.status && item.status === 'disabled') ? ' ' + intl.formatMessage({id: 'admin.fleets.asset.disabled'}) : ''),
            selectable: selectable && this.canBeFleetParentCheck(hasAssets) && this.canBeAssetParentCheck(hasSubFleets),
            items: subItems,
        }
    }

    canBeFleetParentCheck(hasAssets) {
        const {selectableFleetParentsOnly} = this.props
        if(selectableFleetParentsOnly) {
            return !hasAssets;
        }
        return true;
    }

    canBeAssetParentCheck(hasSubFleets) {
        const {selectableAssetParentsOnly} = this.props
        if(selectableAssetParentsOnly) {
            return !hasSubFleets;
        }
        return true;
    }

    render() {
        const {asDropdown, selectionChanged, selectedItems, error, disabled, placeholder} = this.props

        return (
            <React.Fragment>
                <TreeSelector
                    placeholder={placeholder}
                    singleSelection={true}
                    subtreeSelection={false}
                    tree={this.getAssetHierarchyOptions()}
                    asDropdown={asDropdown}
                    selectionChanged={selectionChanged}
                    selectedItems={(selectedItems) ? selectedItems : []}
                    initExpandAll={true}
                    error={error}
                    disabled={disabled}
                />
            </React.Fragment>
        )
    }
}


export default injectIntl(FleetsHierarchy)